module.exports = __webpack_public_path__ + "assets/img/block-right-hover-673b0d88.png";